"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIListNamespace = exports.AIListDomainScopes = exports.AIListEventActions = exports.AIListEventTypes = exports.AIListSourceSystem = exports.ListState = void 0;
var ListState;
(function (ListState) {
    ListState["PUBLIC"] = "PUBLIC";
    ListState["INTERNAL"] = "INTERNAL";
    ListState["PRIVATE"] = "PRIVATE";
})(ListState = exports.ListState || (exports.ListState = {}));
var AIListSourceSystem;
(function (AIListSourceSystem) {
    AIListSourceSystem["ECOMR4"] = "ecomR4";
})(AIListSourceSystem = exports.AIListSourceSystem || (exports.AIListSourceSystem = {}));
var AIListEventTypes;
(function (AIListEventTypes) {
    AIListEventTypes["ListEvent"] = "AIListEvent";
})(AIListEventTypes = exports.AIListEventTypes || (exports.AIListEventTypes = {}));
var AIListEventActions;
(function (AIListEventActions) {
    AIListEventActions["MatchProduct"] = "MatchProduct";
    AIListEventActions["MenuParse"] = "MenuParse";
    AIListEventActions["ListUpdated"] = "AIListUpdated";
})(AIListEventActions = exports.AIListEventActions || (exports.AIListEventActions = {}));
var AIListDomainScopes;
(function (AIListDomainScopes) {
    AIListDomainScopes["AIListDefaultScope"] = "AIList";
})(AIListDomainScopes = exports.AIListDomainScopes || (exports.AIListDomainScopes = {}));
var AIListNamespace;
(function (AIListNamespace) {
    AIListNamespace["AIListNamespace"] = "AIList";
})(AIListNamespace = exports.AIListNamespace || (exports.AIListNamespace = {}));
